import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useCorporateStats } from '../../hooks/docket/statics';
import moment from 'moment';

export default function CorpDocketStats({ data, isLoading }) {
    const [enableApi, setAPI] = React.useState(false)

    const { corpStatsData, isLoadingCorpStats, handleCorpStatsParam } = useCorporateStats('', enableApi);
    data = corpStatsData || data;
    isLoading = isLoadingCorpStats || isLoading;

    const today = new Date();
    const defaultYear = today.getFullYear().toString();
    const defaultMonth = (today.getMonth() + 1).toString().padStart(2, '0');

    const [year, setYear] = useState(defaultYear); // Initialize current year state
    const [month, setMonth] = useState(defaultMonth);
    const [day, setDay] = useState('all');
    const [daysInMonth, setDaysInMonth] = useState([]);

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2021 }, (_, i) => 2022 + i);
    const months = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));

    const pendingCount = data?.pending_dockets + data?.review_dockets + data?.hold_dockets;
    function handleCorpStats({ year, month, day }) {
        if (!year && !month && !day) { }
        setAPI(true)
        // console.log("Filter Params:", { year, month, day });
        handleCorpStatsParam(`?year=${year}&month=${month}&day=${day}`);
        // Fetch filtered data here (e.g. API call)
    }
    // Update day options based on selected year and month
    useEffect(() => {
        if (year && month) {
            const lastDay = new Date(year, month, 0).getDate();
            setDaysInMonth(Array.from({ length: lastDay }, (_, i) => i + 1));
        } else {
            setDaysInMonth([]);
        }
    }, [year, month]);

    // Call filter function on any change
    useEffect(() => {
        handleCorpStats({
            year: year || '',
            month: month || '',
            day: day || 'all',
        });

    }, [year, month, day]);


    if (isLoading) {
        return (
            <div className="">
                <h3 className="text-center text-dark bg-warning py-2 fw-bold">Corporate Dashboard</h3>
                <Skeleton height={40} className="mb-2" />
                <Skeleton height={30} count={4} />
            </div>
        );
    }

    if (!data) {
        return (
            <div className="shadow rounded overflow-hidden ">
                <h3 className="text-center text-light bg-warning py-2 fw-semibold">Corporate Dashboard</h3>
                <div className='p-3'>
                    <p className="text-center text-danger">No data avdailable</p>
                    <div className="text-center mb-3">
                        <button className="btn btn-primary" onClick={() => handleCorpStats({ year, month, day })}>
                            Refresh Data
                        </button>
                    </div>
                    <p className="text-center text-muted">Please select a year, month, and day to filter the data.</p>
                    <div className="row text-white fw-bold py-2 rounded mb-3 mx-0" style={{ backgroundColor: '#98ceba' }}>
                        <div className="col-md-4 my-2">
                            <select
                                className="form-select w-100 mx-auto"
                                value={year}
                                onChange={(e) => {
                                    setYear(e.target.value);
                                    setMonth('');
                                    setDay('');
                                }}>
                                <option value="">Select Year</option>
                                {years.map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-4 my-2">
                            <select
                                className="form-select w-100 mx-auto"
                                value={month}
                                onChange={(e) => {
                                    setMonth(e.target.value);
                                    setDay('');
                                }}
                                disabled={!year}
                            >
                                <option value="">Select Month</option>
                                {months.map((m) => (
                                    <option key={m} value={m}>{m}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-4 my-2">
                            <select
                                className="form-select w-100 mx-auto"
                                value={day}
                                onChange={(e) => setDay(e.target.value)}
                                disabled={!month}
                            >
                                <option value="">All</option>
                                {daysInMonth.map((d) => (
                                    <option key={d} value={d}>{d.toString().padStart(2, '0')}</option>
                                ))}
                            </select>
                        </div>



                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className="shadow rounded overflow-hidden ">
            <h3 className="text-center text-light bg-warning py-2 fw-semibold">Corporate Dashboard</h3>
            <div className='p-3'>
                <p className='text-center'>Last updated at {moment(data?.updated_at).tz('Asia/Kolkata').fromNow()}</p>

                {/* Filter Row */}
                <div className="row text-white fw-bold py-2 rounded mb-3 mx-0" style={{ backgroundColor: '#98ceba' }}>
                    <div className="col-md-4 my-2">
                        <select
                            className="form-select"
                            value={year}
                            onChange={(e) => {
                                setYear(e.target.value);
                                setMonth('');
                                setDay('');
                            }}
                        >
                            <option value="">Year</option>
                            {years.map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 my-2">
                        <select
                            className="form-select"
                            value={month}
                            onChange={(e) => {
                                setMonth(e.target.value);
                                setDay('');
                            }}
                            disabled={!year}
                        >
                            <option value="">Month</option>
                            {months.map((m) => (
                                <option key={m} value={m}>{m.toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 my-2">
                        <select
                            className="form-select"
                            value={day}
                            onChange={(e) => setDay(e.target.value)}
                            disabled={!month}
                        >
                            <option value="">All</option>
                            {daysInMonth.map((d) => (
                                <option key={d} value={d}>{d.toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Responsive Table */}
                <div className="">
                    <table className="table table-bordered text-center w-100 d-table popOverTable">
                        <tbody>
                            <tr style={{ backgroundColor: '#fddede', color: '#000' }}>
                                <th className='text-start px-3'>Total Docket Count</th>
                                <td width="200" className='text-end px-3'>{data.total_dockets}</td>
                                <div className='tooltipText'>
                                    <div className='toolTipInerDiv shadow'>
                                        <h6 className='m-0'>Total Docket</h6>
                                        <p className='m-0'><small>Review: {data?.review_dockets}</small></p>
                                        <p className='m-0'><small>Pending: {data?.pending_dockets}</small></p>
                                        <p className='m-0'><small>Hold: {data?.hold_dockets}</small></p>
                                        <p className='m-0'><small>Closed: {data?.closed_dockets}</small></p>
                                        <p className='m-0'><small>Moved to Fiber: {data?.moved_fiber_dockets}</small></p>
                                    </div>
                                </div>
                            </tr>
                            <tr style={{ backgroundColor: '#d4edda', color: '#000' }}>
                                <th className='text-start px-3 text-black'>Pending Docket Count</th>
                                <td width="200" className='text-end px-3'>{pendingCount}</td>
                                <div className='tooltipText'>
                                    <div className='toolTipInerDiv shadow'>
                                        <h6 className='m-0'>Pending Docket</h6>
                                        <p className='m-0'><small>Review: {data?.review_dockets}</small></p>
                                        <p className='m-0'><small>Pending: {data?.pending_dockets}</small></p>
                                        <p className='m-0'><small>Hold: {data?.hold_dockets}</small></p>
                                    </div>
                                </div>
                            </tr>
                            <tr style={{ backgroundColor: '#eeeeee', color: '#000' }}>
                                <th className='text-start px-3'>Close Docket Count</th>
                                <td width="200" className='text-end px-3'>{data.closed_dockets}</td>
                                <div className='tooltipText'>
                                    <div className='toolTipInerDiv shadow'>
                                        <h6 className='m-0'>Closed Docket</h6>
                                        <p className='m-0'><small>Total: {data.total_dockets}</small></p>
                                        <p className='m-0'><small>Closed: {data.closed_dockets}</small></p>
                                    </div>
                                </div>
                            </tr>
                            <tr style={{ backgroundColor: '#ffff99', color: '#000' }}>
                                <th className='text-start px-3'>Moved To Fiber Docket Count</th>
                                <td width="200" className='text-end px-3'>{data.moved_fiber_dockets}</td>
                                <div className='tooltipText'>
                                    <div className='toolTipInerDiv shadow'>
                                        <h6 className='m-0'>Moved to Fiber</h6>
                                        <p className='m-0'><small>Total: {data.total_dockets}</small></p>
                                        <p className='m-0'><small>Moved to Fiber: {data.moved_fiber_dockets}</small></p>
                                    </div>
                                </div>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
